// @view/document/DocumentDetailsPrompt.view.tsx

import React, { useState } from "react";
import * as styles from "@styles/DocumentLevelPrompt.css";

import * as IO from "@ps-bridge/interop/io";
import { ok } from "@ps-bridge/ok";
import type { DocumentDetailsPromptViewProps } from "@ps-bridge/contracts/documentDetailsPrompt";
import { renderMarkdownHtml } from "@utils/markdown";
import { useDocumentAssistantDictation } from "@hooks/useDocumentAssistantDictation";
import DocumentAssistantDictationControl from "@view/document/DocumentAssistantDictationControl";

const DocumentDetailsPromptComponent: React.FC<DocumentDetailsPromptViewProps> = ({
  documentQuestion,
  onSubmit,
}) => {
  const [userInput, setUserInputImpure] = useState<string>("");
  const dictation = useDocumentAssistantDictation({
    fieldId: "documentDetailsPrompt",
    value: userInput,
    setValue: (value) => {
      setUserInputImpure(value);
      return ok;
    },
  });

  return (
    <div className={styles.container}>
      <p className={styles.header}>Document Level Question</p>
      <div className={styles.documentQuestionContainer}>
        <div
          data-testid="document-details-question-markdown"
          className={styles.documentQuestion}
          dangerouslySetInnerHTML={{ __html: renderMarkdownHtml(documentQuestion) }}
        />
      </div>
      <textarea
        ref={dictation.inputBindings.ref}
        data-testid="document-details-prompt-answer-input"
        className={styles.input}
        value={userInput}
        onChange={(event) => setUserInputImpure(event.target.value)}
        onClick={dictation.inputBindings.onClick}
        onFocus={dictation.inputBindings.onFocus}
        onSelect={dictation.inputBindings.onSelect}
        placeholder="You can also provide additional context or examples in addition to responding to the questions."
        rows={6}
      />
      <DocumentAssistantDictationControl
        {...dictation.controlState}
        buttonClassName={styles.button2}
        iconClassName=""
      />
      <button
        data-testid="document-details-prompt-submit"
        className={styles.button2}
        onClick={() => {
          IO.run(onSubmit(userInput));
          setUserInputImpure("");
        }}
      >
        Submit
      </button>
    </div>
  );
};

export default DocumentDetailsPromptComponent;
